import React from "react";

const DocumentDetailContext = React.createContext({});

export const DocumentDetailContextProvider = DocumentDetailContext.Provider;
export const DocumentDetailContextConsumer = DocumentDetailContext.Consumer;
export default DocumentDetailContext;
